import _ from "lodash"

const initialState = () => ({
    isLoading: true,
    sections: {
        requests: {
            size: 1
        },
        scheduled: {
            size: 1
        }
    },
    filters: {
        deliveryDate: null,
        clientGroups: [],
        responsibleUsers: [],
        promotionChannels: [],
        status: []
    }, 
    ordinations: {
        deliveryDate: null,
        responsibleUser: null,
    }
});

const state = initialState

const getters = {
};

const mutations = {
    SET_IS_LOADING(state, isLoading){
        state.isLoading = isLoading
    },
    SET_DELIVERY_DATE(state, date){
        state.isLoading = true
        state.filters.deliveryDate = date
    },
    SET_FILTER(state, { type, select = true, id }) {
        if (select && !_.includes(state.filters[type], id)) {
            state.filters[type].push(id);
        } else if (!select && _.includes(state.filters[type], id)) {
            state.filters[type].splice(state.filters[type].indexOf(id), 1);
        }
    },
    REPLACE_FILTERS(state, { type, values }) {
        state.filters[type] = values
    },
    SET_ORDINATION(state, { type, value }) {
        state.ordinations[type] = value 
    },
    EXPAND_SECTION(state, sectionId) {
        if (_.get(state, `sections[${sectionId}].size`, false)) {
            if(state.sections[sectionId].size < 3){
                state.sections[sectionId].size += 1;
            }
        } else {
            state.sections[sectionId].size = 1;
        }
    },
    COLLAPSE_SECTION(state, sectionId) {
        if (_.get(state, `sections[${sectionId}].size`, false)) {
            if (state.sections[sectionId].size === 0) {
                state.sections[sectionId].size = 0;
            } else {
                state.sections[sectionId].size -= 1;
            }
        }
    },
    RESET_STATE(state) {
        const initial = initialState();
        Object.keys(initial).forEach(key => {
            state[key] = initial[key];
        });
    }
};

const actions = {
    setIsLoading(context, isLoading){
        context.commit("SET_IS_LOADING", isLoading);
    },
    expandSection(context, sectionId) {
        context.commit("EXPAND_SECTION", sectionId);
    },
    collapseSection(context, sectionId) {
        context.commit("COLLAPSE_SECTION", sectionId);
    },
    resetState(context) {
        context.commit("RESET_STATE");
    },
    setFilter(context, objValue) {
        context.commit('SET_FILTER', objValue)
    },
    setOrdination(context, obj) {
        context.commit('SET_ORDINATION', obj)
    },
    replaceFilters(context, obj) {
        context.commit('REPLACE_FILTERS', obj)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
